<script setup>
import { ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert as wgptUserAlert } from 'dashboard/composables/wgpt';
import { useAlert } from 'dashboard/composables';

import Dialog from 'next/dialog/Dialog.vue';

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const bot = ref({});
const chunk = ref({});
const dialogRef = ref(null);
const uiFlags = getters['wgptBotSourceChunks/getUIFlags'];

const handleDialogConfirm = async () => {
  try {
    await store.dispatch('wgptBotSourceChunks/delete', {
      botId: bot.value.id,
      sourceId: chunk.value.sourceId,
      id: chunk.value.id,
    });

    useAlert(
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.DELETE.API.SUCCESS_MESSAGE'
      )
    );
    dialogRef.value.close();
  } catch (error) {
    wgptUserAlert(
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.DELETE.API.ERROR_MESSAGE'
      )
    );
  }
};

const open = (selectedBot, selectedChunk) => {
  bot.value = selectedBot;
  chunk.value = selectedChunk;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.DELETE.CONFIRM.TITLE'
      )
    "
    :description="
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.DELETE.CONFIRM.MESSAGE'
      )
    "
    :confirm-button-label="
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.DELETE.CONFIRM.YES'
      )
    "
    :cancel-button-label="
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.DELETE.CONFIRM.NO'
      )
    "
    :is-loading="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
